/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import typography from "assets/theme/base/typography";

function configs(
  labels: any,
  datasets: any,
  stacked?: boolean,
  tooltipPrecision?: number,
  legendPosition?: "top" | "left" | "bottom" | "right" | "chartArea"
) {
  return {
    data: {
      labels,
      datasets: [...datasets],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: legendPosition ?? "top",
        },
        tooltip: {
          callbacks: {
            label: function (context: any) {
              let label = context.dataset.label || "";

              if (label) label += ": ";
              if (context.parsed.y !== null) {
                label += new Intl.NumberFormat("en-US").format(
                  context.parsed.y.toFixed(tooltipPrecision ?? 0)
                );
              }

              return label;
            },
          },
        },
      },
      animation: false,
      scales: {
        y: {
          stacked: stacked ?? false,
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
          },
          ticks: {
            display: true,
            padding: 10,
            color: "black",
            font: {
              size: 14,
              family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
            callback: (value: number) => {
              return new Intl.NumberFormat("en-US").format(value);
            },
          },
        },
        x: {
          stacked: stacked ?? false,
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: true,
            drawTicks: true,
          },
          ticks: {
            display: true,
            color: "black",
            padding: 10,
            font: {
              size: 14,
              family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
    },
  };
}

export default configs;
